export default __webpack_public_path__ + "static/19_tao_tao-d28703d84b1e7b9020c7459f7ac780f5.png";